// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card-container[data-v-ecec6e86]{display:grid;grid-template-columns:auto 1fr;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:6rem;background:#f3f3f3;padding:.5rem;border-radius:5px}", ""]);
// Exports
module.exports = exports;
